<template lang="html">
  <b-modal
    :id="modalId"
    no-close-on-backdrop
    size="xl"
    @shown="init"
    @hidden="hideModal"
  >
    <template v-slot:modal-header>
      <div>
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <div>{{ modalSubtitle }}</div>
      </div>
    </template>
    <sales-edit
      v-if="hasData"
      :appId="appId"
      :all-des="desClone"
      :de="dataElement"
      :app-type="$attrs.appType"
      @on-de-name-changed="onDeNameChanged"
    />
    <template v-slot:modal-footer>
      <button
        class="modal-btn no-user-select modal-cancel-btn"
        @click="hideModal"
      >
        {{ getMessageText(messages.CANCEL) }}
      </button>
      <button
        class="modal-btn no-user-select modal-save-btn"
        :disabled="isDisabled"
        @click="finishQuery()"
      >
        {{ getMessageText(messages.OK) }}
      </button>
    </template>
  </b-modal>
</template>

<script lang="js">
  import { mapState, mapGetters } from "vuex";
  import { MUTATION_NAME } from "@/static/global-variables";
  import utils from "@/utils";
  import store from "@/store";
  import validatorUtil from "@/utils/validator-util";
  import SalesEdit from "@/components/queries/sales-data/SalesEdit";

  export default {
    name: "SalesEditModal",
    components: {
      SalesEdit
    },
    props: {
      appId: String,
      de: Object,
      id: String,
      name: String,
      allDes: Object
    },
    data() {
      return {
        dataElement: null,
        desClone: null,
        isNameValid: false
      };
    },
    computed: {
      ...mapState({
        messages: "messages",
        editDataElement: "editDataElement"
      }),
      modalId() {
        return "sales-edit-modal_" + this.de.id;
      },
      isDisabled() {
        return !validatorUtil.isValidEditElement(this.editDataElement) || !this.isNameValid;
      },
      hasData() {
        return Boolean(this.dataElement);
      },
      modalTitle() {
        return `${this.getMessageText(this.messages.Edit)} ${this.$t(
          utils.getDataElementLabel(this.de.type)
        )}`;
      },
      modalSubtitle() {
        return utils.getModalSubtitle(this.de.type);
      }
    },
    methods: {
      ...mapGetters([
        "formattedDataElement"
      ]),
      hideModal() {
        if (this.de.notReady) {
          const params = {
            appId: this.de.appId,
            deId: this.de.id
          };
          store.commit(MUTATION_NAME.DELETE_DATA_ELEMENT, params);
        }
        this.dataElement = null;
        this.$bvModal.hide(this.modalId);
      },
      finishQuery() {
        store.commit(MUTATION_NAME.UPDATE_DE_QUERY, this.formattedDataElement());
        this.$bvModal.hide(this.modalId);
      },
      init() {
        this.dataElement = JSON.parse(JSON.stringify(this.de));
        this.desClone = JSON.parse(JSON.stringify(this.allDes));
      },
      onDeNameChanged(val) {
        this.isNameValid = val;
      }
    }
  };
</script>
